import { ActionTypes } from "../constants/index";

export default (state = false, action) => {
  switch (action.type) {
    case ActionTypes.SHOW_SPINNER:
      return true;
    case ActionTypes.HIDE_SPINNER:
      return false;
    default:
      return state;
  }
};
